import React from "react";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import { TextFieldProps } from "@mapmycustomers/ui";

import ActivityNameField from "../ActivityNameField";

interface LockedActivityNameProps
  extends Pick<TextFieldProps, "caption" | "placeholder" | "required"> {
  activityTypes: ActivityType[];
}

const LockedActivityName: React.FC<LockedActivityNameProps> = ({ activityTypes, ...props }) => {
  return <ActivityNameField activityTypes={activityTypes} {...props} disabled />;
};

export default LockedActivityName;
